export class LibraryModel {
    id = '';
    name = '';
    size = '';
    height = 0;
    width = 0;
    description = '';
    url = '';
    videoImage = '';
    type: 'folder' | 'image' | 'video' | 'audio' | 'link' = 'folder';
    parentId = '';
    path = '';
    createDate: any = null;
    createBy = '';
    modifiedDate: any = null;
    modifiedBy = '';
    fromAdmin = 0;
    children: any[] = [];
    source?: null | 'message' | 'avatar' = null;
}